import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class CircleIcon extends Component {
    render() {
        return (
            <svg {...this.props} viewBox="0 0 20 20"><circle cx="10" cy="10" r="10"/></svg>
        )
    }
}

export default withCssClassName(CircleIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/circle-icon.js